<template>
	<div id="tu-course-cancel">
		<div class="left">
			<div class="back" @click="toBack"> 
				<i class="fa fa-chevron-left"></i> <span>{{$t("go-back")}}</span>
			</div>
			<template v-if="isStudent">
				<div class="title">
					
				</div>
				<div class="content">
					<div class="tips">
						{{cancel_tips}}
					</div>
					<div style="height: 10px;"></div>
					<div class="reason_title">Cancellation Reason</div>
					<div class="group">
						<el-input v-model="content" :rows="5" type="textarea" />
					</div>
				</div>
			</template>
			<template v-else>
				<div class="title">Cancel lesson with {{detail?.user_info.nickname}}</div>
				<div class="reason" v-if="detail?.cancel_status == 1 && detail?.cancel_desc?.tran">
					<div class="reason_title">Cancellation Reason</div>
					<div class="reason_content">{{detail?.cancel_desc?.tran||detail?.cancel_desc?.reason}}</div>
				</div>
				<div class="reason" v-if="detail?.cancel_status == 2">
					<div class="reason_title">Cancellation Reason</div>
					<div class="group">
						<el-radio-group v-model="type" size="large" style="display: flex; flex-direction: column;font-size: 18px;">
							<el-radio label="2">Tutors' schedule changes</el-radio>
							<el-radio label="1">Students' schedule changes</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="content" v-if="type==1||detail?.cancel_status == 1">
					<div class="tip">This lesson is eligible for a cancellation charge as it is due to start in less than 24 hours. Use the options below to waive or enforce the charge.</div>
					<div class="sub-title">What percentage of the lesson price would you like to charge?</div>
					<div class="group">
						<el-radio-group v-model="value" size="large" style="display: flex; flex-direction: column;">
							<el-radio label="0">0%</el-radio>
							<el-radio label="50">50%</el-radio>
							<el-radio label="100">100%</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="footer">{{detail?.user_info.nickname}} will be charged {{ money }}. If you have questions or need any help at all, please feel free to get in touch.</div>
			</template>


			<div class="button">
				<el-link type="primary" @click="toBack">{{$t("go-back")}}</el-link>
				<div v-if="isStudent">
					<el-button class="tu-button" type="primary" @click="cancelLessonForStudent">
						Cancel lesson <i class="fa fa-arrow-right"></i>
					</el-button>
				</div>
				<div v-else>
					<el-button class="tu-button" type="primary" @click="cancelLesson">
						Cancel lesson <i class="fa fa-arrow-right"></i>
					</el-button>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="wrap">
				<div class="title">{{$t("detail")}}</div>
				<div class="info">
					<div class="avatar">
				        <el-avatar v-if="detail?.user_info?.avatar_url" :size="60" :src="detail?.user_info?.avatar_url"></el-avatar>
				        <el-avatar v-else :size="60">{{ detail?.user_info?.slot }}</el-avatar>
					</div>
					<div class="detail">
						<div>{{detail?.user_info?.nickname}}</div>
						<div>{{detail?.subject?.subject_name}}({{detail?.subject?.level_name}})</div>
						<div>{{detail?.book?.time}} {{detail?.book?.min_time}} - {{detail?.book?.max_time}}</div>
					</div>
				</div>
				<div class="price">
					<div>{{$t("noun.Price")}}</div>
					<div v-if="!!detail?.pay_rmb_fee">{{ detail?.pay_rmb_fee }}</div>
					<div v-else>{{ detail?.currency }}{{ detail?.price }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CourseApi from '@/api/course'
import TimeControl from '@/utils/time-control'

export default {
	name: "course-cancel",
	components: {
	},
	data() {
		return {
			id: 0,
			detail: null,
			value: "",
			type: "2", // 谁的原因
			content: "",
			cancel_tips: ""
		}
	},
	created() {
		this.id = this.$route.params.id;
		if(this.id) {
			this.getApiDetailData();
		}
	},
	computed: {
		...mapGetters([
			'isStudent'
		]),
		money() {
			// {{ detail?.currency }}
			let money = 0;
			if (this.value) {
				let price = parseFloat(this.detail?.price);
				money = price * (parseInt(this.value)/100);
				money = money.toFixed(2)
			}
			return this.detail?.currency + money;
		}
	},
	methods: {
		getApiDetailData() {
			if(!!!this.id || /^\d+$/.test(this.id) === false) {
				this.$message.error(this.$t('exception.request'))
				this.$router.push({path: '/course'})
				return ;
			}
			CourseApi.info(this.id).then((res) => {
				this.detail = res.data;
				this.detail.book = {
					time: TimeControl.getFormatTime(this.detail.book_time, "Do MMMM"),
					min_time: TimeControl.getFormatTime(this.detail.book_time, "HH:mm"),
					max_time: TimeControl.getFormatTime(this.detail.book_time + this.detail.second, "HH:mm")
				}
				this.content = this.detail.cancel_desc.reason || "";

				// 判断是否在24小时外
				let book_time = this.detail.book_time;
				let now_time = (new Date).getTime()/1000;
				if(book_time > (now_time + 86400)) {
					this.cancel_tips = "友情提示：本次取消距离上课开始超过24小时，取消免费。";
				} else {
					this.cancel_tips = "本次取消距离上课开始不足24小时，可能会被收取50%或100%的课时费。强烈建议您向老师说明取消原因，是否扣费以及具体比例将由老师决定。";
				}	
			});
		},

		toBack() {
			this.$router.push({ path: `/course/${this.id}` });
		},

		// CourseApi.cancel
		// CourseApi.cancelling
		cancelLesson() {
			if (this.value == "" && (this.type == 1 || this.detail.cancel_status == 1)) {
				this.$message.error("What percentage of the lesson price would you like to charge?")
				return
			}
			if (this.detail.cancel_status == 1) {
				CourseApi.cancelling(this.id, {scale: this.value}).then(res => {
					this.$message.success("Course cancelled successfully.");
					setTimeout(() => {
						this.toBack();
					}, 2000);
				})
			} else {
				CourseApi.cancel(this.id, {scale: this.value, type: this.type}).then(res => {
					this.$message.success("Course cancelled successfully.");
					setTimeout(() => {
						this.toBack();
					}, 2000);
				})
			}
		},
		cancelLessonForStudent() {
			let book_time = this.detail.book_time;
			let now_time = (new Date).getTime()/1000;
			if (book_time <= now_time) {
				this.$message.error("当前课程不可取消");
				return
			}
			CourseApi.cancel(this.id, {reason: this.content}).then(res => {
				this.$message.success("Course cancelled successfully.");
				setTimeout(() => {
					this.toBack();
				}, 2000);
			})
		}
	}
}
</script>
<style lang="less">
#tu-course-cancel {
	display: flex;
	justify-content: space-between;
	padding: 0 100px;

	.left {
		width: 70%;

		.back {
			font-size: 20px;
			cursor: pointer;
		}

		.title {
			margin: 20px 0;
			font-weight: 500;
			font-size: 28px;
			line-height: 1.2;
		}

		.reason {
			.reason_title {
				font-size: 18px;
				font-weight: 500;
			}

			.reason_content {
				font-size: 14px;
				line-height: 20px;
				margin-top: 10px;
				border: 1px solid #CCCCCC;
				border-radius: 4px;
				padding: 10px;


			}

			.group {
				margin-top: 10px;

				.el-radio__label {
					font-weight: 600;
				}

				.el-radio {
					height: 30px;

					.el-radio__inner {
						width: 18px;
						height: 18px;
					}

					.el-radio__inner::after {
						width: 6px;
						height: 6px;
					}
				}
			}
		}

		.content {
			margin-top: 20px;

			.tip {
				color: #909399;
				line-height: 20px;
			}
			.sub-title {
				margin-top: 20px;
				font-weight: 600;
				font-size: 18px;
			}
			.group {
				margin-top: 10px;

				.el-radio__label {
					font-weight: 600;
				}

				.el-radio {
					height: 30px;

					.el-radio__inner {
						width: 18px;
						height: 18px;
					}

					.el-radio__inner::after {
						width: 6px;
						height: 6px;
					}
				}
			}
		}

		.footer {
			font-size: 14px;
			margin-top: 15px;
		}

		.button {
			margin-top: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tu-button {
				font-weight: 600;
			}
		}
	}

	.right {
		padding-top: 40px;
		.wrap {
			width: 100%;
			border: 1px solid #CCCCCC;
			padding: 10px;
			border-radius: 4px;

			.title {
				font-size: 18px;
				font-weight: 600;
				padding: 10px 0;
				border-bottom: 1px solid #CCCCCC;
			}
			.info {
				padding: 15px 0;
				display: flex;
				gap: 10px;
				align-items:center;
				justify-content: flex-start;
				border-bottom: 1px solid #CCCCCC;

				.avatar {
					.image {
				       	width: 120px;
				       	height: 120px;
				       	flex-shrink: 0;
					}
				}

				.detail {
					font-size: 12px;
					line-height: 14px;
					div:first-child {
						font-weight: 600;
						font-size: 14px;
						margin-bottom: 5px;
					}
				}
			}
			.price {
				margin-top: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 14px;
			}
		}
	}
}
</style>